import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import GameRule from '@/components/GameRule'
import Register from '@/components/Register'
import Introduction from '@/components/Introduction'
import ActiveDetail from '@/components/ActiveDetail'
import Winner from '@/components/Winner'
import WinRecord from '@/components/WinRecord'
import Want from '@/pages/Want'

Vue.use(Router)

export default new Router({

  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/want',
      name: 'Want',
      component: Want
    },
    {
      path: '/gameRule',
      name: 'gameRule',
      component: GameRule
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/introduction',
      name: 'introduction',
      component: Introduction
    },
    {
      path: '/winner',
      name: 'winner',
      component: Winner
    },
    {
      path: '/activedetail',
      name: 'activedetail',
      component: ActiveDetail
    },
    {
      path: '/winrecord',
      name: 'winrecord',
      component: WinRecord
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js